import { trace } from "@opentelemetry/api";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { DocumentLoadInstrumentation } from "@opentelemetry/instrumentation-document-load";
import { FetchInstrumentation } from "@opentelemetry/instrumentation-fetch";
import { XMLHttpRequestInstrumentation } from "@opentelemetry/instrumentation-xml-http-request";
import { resourceFromAttributes } from "@opentelemetry/resources";
import {
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_VERSION,
} from "@opentelemetry/semantic-conventions";

import pkg from "../../package.json";

const DEFAULT_TRACES_ENDPOINT = "/otel/v1/traces";
const DEFAULT_SERVICE_NAME = "app-shell";
const TRACE_PROPAGATION_URLS = [
  /^https:\/\/([a-z0-9-]+\.)*jvs-mairistem\.dev\//,
  /^https:\/\/([a-z0-9-]+\.)*jvsonline\.fr\//,
  /^https:\/\/([a-z0-9-]+\.)*looc\.fr\//,
  /^https:\/\/([a-z0-9-]+\.)*jvsonline\.cloud\//,
];

const buildTracesEndpoint = (rawEndpoint?: string) => {
  if (!rawEndpoint) return DEFAULT_TRACES_ENDPOINT;

  const normalizedEndpoint = rawEndpoint.trim().replace(/\/+$/, "");

  if (/\/v1\/traces$/.test(normalizedEndpoint)) {
    return normalizedEndpoint;
  }

  return `${normalizedEndpoint}/v1/traces`;
};

export const initializeTracing = () => {
  console.log("Initializing OpenTelemetry...");

  const tracesEndpoint = buildTracesEndpoint(
    import.meta.env.VITE_OTEL_EXPORTER_OTLP_TRACES_ENDPOINT,
  );

  const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      [ATTR_SERVICE_NAME]:
        import.meta.env.VITE_OTEL_SERVICE_NAME || DEFAULT_SERVICE_NAME,
      [ATTR_SERVICE_VERSION]:
        import.meta.env.VITE_OTEL_SERVICE_VERSION || pkg.version,
      deployment_environment:
        import.meta.env.VITE_OTEL_ENVIRONMENT || "dev",
    }),
    spanProcessors: [
      new BatchSpanProcessor(
        new OTLPTraceExporter({
          url: tracesEndpoint,
        }),
      ),
    ],
  });

  provider.register({
    contextManager: new ZoneContextManager(),
  });

  registerInstrumentations({
  instrumentations: [
    new DocumentLoadInstrumentation(),
    new FetchInstrumentation({
      propagateTraceHeaderCorsUrls: TRACE_PROPAGATION_URLS,
    }),
    new XMLHttpRequestInstrumentation({
      propagateTraceHeaderCorsUrls: TRACE_PROPAGATION_URLS,
    }),
  ],
});

  const tracer = trace.getTracer("frontend-test");
  const span = tracer.startSpan("application-start");

  span.setAttribute("environment", import.meta.env.VITE_OTEL_ENVIRONMENT || "dev");
  span.setAttribute("version", pkg.version);
  span.end();

  console.log("Test span sent");
  console.log("OTLP traces endpoint:", tracesEndpoint);
};